import { Box, Card } from "@mui/material";
import { supportEmail as defaultSupportEmail } from "@constants";
import { useWebApiV1GetTenantConfigQuery } from "@providers/hop-ord-server/api";
import { useAppSelector } from "@hooks";
import { LoadingIcon } from "@components/LoadingIcon";

const ErrorPage = (): JSX.Element => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  const { data: tenantConfig, isLoading } = useWebApiV1GetTenantConfigQuery(
    undefined,
    {
      skip: !isAuthenticated,
    },
  );

  const supportEmail =
    tenantConfig?.support_email?.trim() || defaultSupportEmail;

  return (
    <Box
      style={{
        display: "flex",
        backgroundSize: "cover",
        height: "100vh",
        width: "100vw",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px",
        margin: "0px",
      }}
    >
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <Card style={{ padding: "2em", margin: "2em" }}>
          <div data-testid="error-title">
            You do not have permission to view this page
          </div>
          <span data-testid="error-detail">
            If you believe you are seeing this screen in error, please contact
            Lumonus IT support at{" "}
            <a
              data-testid="support-email"
              href={supportEmail ? `mailto:${supportEmail}` : ""}
            >
              {supportEmail}
            </a>
          </span>
        </Card>
      )}
    </Box>
  );
};

export default ErrorPage;
